import Logins from '../Auth/Signin';

export const authRoutes = [
  { path: `/login`, Component: <Logins /> }
];
